import template from './loginHeader.html';

export default {
    templateUrl: template
};


/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/components/header/loginHeaderComponent.js
 **/